import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthCommonService } from './auth.service';

@Injectable({
  providedIn: 'root'
})


export class AuthGuard {
    readonly _domainName?: string ="";
  constructor(private router: Router,private authCommonService: AuthCommonService) {
  }

  async canActivate( route: ActivatedRouteSnapshot,state: RouterStateSnapshot): Promise<boolean> {
    var authToken = this.authCommonService.getCookieValue('LOGIN_TOKEN');
    var isTokenValid =  await this.authCommonService.isTokenValid(authToken);
    
    if (isTokenValid) {
     return true; // User is logged in and token is valid, allow access
    } else {
       let originalUrl = decodeURIComponent(state.url);
       const match = originalUrl.match(/d=([^&]+)/);
         if (match && match[1]) {
           try {
             const parsed = this.decryptUrlParams(match[1]);
             if (parsed.EngagementId && parsed.TabId) {
               originalUrl = `/ViewEngagement/${parsed.EngagementId}/${parsed.TabId}`;
             }
           else if (parsed.ContractId && parsed.TabId) {
          const currency = encodeURIComponent(parsed.currency || '');
          const subTabId = parsed.SubTabId || '0';
          originalUrl = `/viewcontract/${parsed.ContractId}/${currency}/${parsed.TabId}/${subTabId}`;
        }
      } catch (err) {
      }
         }
         const baseUrl = (this.authCommonService?._kontractProAppURl ?? '').replace(/\/$/, '');
         const fullRedirectUrl = `${baseUrl}${originalUrl.startsWith('/') ? originalUrl : '/' + originalUrl}`;
        const loginURL = `${this.authCommonService!._loginPortalAppURl}?redirect=${fullRedirectUrl}`;
        console.log('Redirecting to login:', loginURL);
      window.location.href = loginURL;
         return false;
       
       
           }
  }
private decryptUrlParams(encoded: string): any {
  try {
    const decoded = decodeURIComponent(encoded);
    const json = atob(decoded);
    return JSON.parse(json);
  } catch (error) {
    console.error('Error during decryptUrlParams:', error);
    return {};
  }
}


}






